import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setStatusMessage('Please fill in both fields.');
      return;
    }

    if (password !== confirmPassword) {
      setStatusMessage('Passwords do not match.');
      return;
    }

    setIsSubmitting(true);
    setStatusMessage('');

    try {
      // Connects to your backend endpoint for password update
      const response = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password })
      });

      const data = await response.json();

      if (response.ok) {
        setStatusMessage('Password successfully updated! Redirecting to login...');
        setTimeout(() => navigate('/'), 3000);
      } else {
        setStatusMessage(data.error || 'Failed to reset password. Please try again.');
        setIsSubmitting(false);
      }
    } catch (err) {
      setStatusMessage('A network error occurred. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reset-password-container" style={{ padding: '40px', maxWidth: '400px', margin: '40px auto', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: '20px', textAlign: 'center', color: '#1E3A8A' }}>Set New Password</h2>
      
      {statusMessage && (
        <div style={{ padding: '10px', marginBottom: '15px', background: '#F3F4F6', color: '#374151', borderRadius: '4px', textAlign: 'center', fontSize: '14px' }}>
          {statusMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>New Password</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            placeholder="Enter new password" 
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #D1D5DB', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>Confirm Password</label>
          <input 
            type="password" 
            value={confirmPassword} 
            onChange={(e) => setConfirmPassword(e.target.value)} 
            placeholder="Confirm new password" 
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #D1D5DB', boxSizing: 'border-box' }}
          />
        </div>

        <button 
          type="submit" 
          disabled={isSubmitting}
          style={{ width: '100%', padding: '10px', background: '#1D4ED8', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          {isSubmitting ? 'Updating...' : 'Reset Password'}
        </button>
      </form>
    </div>
  );
}